// extracted by mini-css-extract-plugin
export default {"container":"PDFViewer_container__1VroZ"};